import {
  ArrayInput,
  AutocompleteInput,
  BooleanInput,
  DateTimeInput,
  Edit,
  FormDataConsumer,
  ImageInput,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  Title,
  useRecordContext,
} from "react-admin";
import {
  COMMUNITY_POST_STATUS_CHOICES,
  COMMUNITY_POST_TYPES_CHOICES,
} from "../utils/CommunityPostUtils";
import { validateRequired } from "../utils/Validations";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";
import { IMAGE_MAX_SIZE } from "../constants/FileConstants";
import ImagePreview from "../common/ImagePreview";
import { COMMUNITY_POST_TYPES } from "../enums/CommunityPost";
import { SimpleForm } from "../common/SimpleForm";
import { getCountries } from "../enums/Countries";

const CommunityPostTitle = () => {
  const record = useRecordContext();
  return <Title title={`Publicación "${record?.content}"`} />;
};

const CommunityPostEdit = () => {
  return (
    <Edit
      title={<CommunityPostTitle />}
      mutationMode="pessimistic"
      redirect="list"
    >
      <SimpleForm>
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <>
              <TextInput
                source="content"
                label="Contenido"
                multiline
                fullWidth
              />
              <ImageInput
                source="images"
                accept={{
                  "image/*": [],
                }}
                label="Imágenes"
                multiple
                maxSize={IMAGE_MAX_SIZE}
              >
                <ImagePreview source="url" />
              </ImageInput>
              <SelectArrayInput
                source="countries"
                label="Países"
                choices={getCountries()}
                validate={validateRequired}
              />
              <ReferenceInput
                source="restaurant"
                reference="restaurants"
                label="Restaurante"
                perPage={100}
                filter={{
                  active: true,
                  type: RESTAURANT_TYPES.REGULAR,
                  ...(formData?.countries && { country: formData.countries }),
                }}
                filterToQuery={(searchText) => ({ name: searchText })}
              >
                <AutocompleteInput
                  filterToQuery={(searchText) => ({ name: searchText })}
                  label="Restaurante"
                  optionText="name"
                  fullWidth
                />
              </ReferenceInput>
              <ReferenceInput
                source="user"
                reference="users"
                label="Usuario"
                perPage={100}
                filter={{
                  "profile.verified": true,
                  active: true,
                }}
                filterToQuery={(searchText) => ({ email: searchText })}
              >
                <AutocompleteInput
                  filterToQuery={(searchText) => ({ email: searchText })}
                  label="Usuario"
                  optionText="email"
                  fullWidth
                  validate={validateRequired}
                />
              </ReferenceInput>
              <SelectInput
                source="type"
                label="Tipo"
                choices={COMMUNITY_POST_TYPES_CHOICES}
                validate={validateRequired}
              />
              {formData?.type === COMMUNITY_POST_TYPES.SURVEY && (
                <ArrayInput source="surveyOptions" label="">
                  <SimpleFormIterator
                    disableAdd={formData.surveyOptions?.length >= 2}
                    disableReordering
                    getItemLabel={(index) => `#${index + 1}`}
                  >
                    <TextInput source="option" label="Opción" />
                  </SimpleFormIterator>
                </ArrayInput>
              )}
              {formData?.type === COMMUNITY_POST_TYPES.SURVEY && (
                <DateTimeInput
                  source="surveyDeadline"
                  label="Fecha límite"
                  parse={(v) => (v ? new Date(v).toISOString() : null)}
                />
              )}
              <BooleanInput source="pinned" label="Fijado" />
              <SelectInput
                source="status"
                label="Estado"
                choices={COMMUNITY_POST_STATUS_CHOICES}
                validate={validateRequired}
              />
            </>
          )}
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  );
};

export default CommunityPostEdit;
